import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../hooks/useAppDispatch";
import { RootState } from "../../../../redux/store";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";

const LOCALE =
  "modules_MyGiftTable_components_AsideSection_PhysicalProductsValue";

const PhysicalProductsValue: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const [shouldBlink, setShouldBlink] = useState(false);
  const products = useAppSelector(
    (state: RootState) => state.giftTable.products
  );

  // Calculate total value of physical products that are taken
  const physicalProductsValue =
    products
      ?.filter((product) => product.isPhysical)
      .reduce((sum, product) => sum + product.value * product.quantity, 0) || 0;

  // Trigger blink animation when physicalProductsValue changes
  useEffect(() => {
    setShouldBlink(true);
    const timer = setTimeout(() => setShouldBlink(false), 1000);
    return () => clearTimeout(timer);
  }, [physicalProductsValue]);

  return (
    <div
      className={`bg-secondary p-4 rounded-md space-y-4 ${
        shouldBlink ? "highlight-blink" : ""
      }`}
    >
      <div>
        <p className="text-sm">{t("title")}</p>
        <h4 className="text-lg font-bold">
          {physicalProductsValue.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          })}
        </h4>
      </div>
    </div>
  );
};

export default withTranslations(LOCALE)(PhysicalProductsValue);
